import '@styles/pages/ideal-location.scss';

import { initMapFilters } from './ideal-location/map-filters';

initMapFilters();
